<template>
  <van-popup
    v-model:show="showDetail"
    round
    position="bottom"
    @closed="handlerClose()"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
    :close-on-popstate="false"
  >
    <loading :show-loading="showLoading" />
    <div class="card-detail" v-if="item">
      <div style="padding: 0px 16px">
        <div class="close-line">
          <div class="close-line-item"></div>
        </div>
        <h4 class="detail-title">{{ $t("confirm_your_purchase") }}</h4>
        <ConfirmServiceItem :data="item" />
        <hr class="card-line" />
        <div class="card-description" v-if="item.fullDes">
          <div v-html="item.fullDes"></div>
        </div>
        <div class="card-description" v-else>
          <div>{{ $t("Service package description is not available") }}</div>
        </div>
        <hr class="card-line" />

        <!-- input field for phone number -->
        <div>
          <div class="phone-number-title">
            {{ $t("phone_number") }}
            <van-popover
              v-model:show="showPopoverNunberPhoneInfo"
              theme="dark"
              placement="right-start"
            >
              <!-- 
              <template #reference>
                <van-icon name="info-o" />
              </template>
            -->
              <template #default>
                <div style="padding: 6px 10px; max-width: 13em">
                  <p style="margin: 0px; font-size: 10px">
                    {{ $t("you_can_buy") }}
                  </p>
                </div>
              </template>
            </van-popover>
          </div>
          <div class="phone-number" style="padding: 2px 10px 2px 10px">
            <input
              ref="phoneNumberInput"
              @input="debounceInput"
              v-model="phoneNumber"
              type="text"
              inputmode="numeric"
              style="width: 85%; border: none"
              maxlength="19"
              minlength="7"
              @keydown="handleKeyDown2"
              @click="handleClick"
              @paste="handlePaste"
              readonly="true"
            />
          </div>
          <div v-if="checkIsdn" class="input-errors">
            <div class="error-msg">{{ $t("phone_number_invalid") }}</div>
          </div>
          <div
            v-else
            class="input-errors"
            v-for="error of v$.phoneNumber.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ $t("phone_number_invalid") }}</div>
          </div>
        </div>
        <!-- -->
      </div>

      <!--      <div class="aba-pay">-->
      <!--        <div class="brand-box">-->
      <!--          <img src="@/static/aba-pay.png" />-->
      <!--        </div>-->
      <!--        <div class="content-apa-pay">-->
      <!--          <div class="content-left">-->
      <!--              <h4 class="title-apa-pay">-->
      <!--                  Savings Account-->
      <!--              </h4>-->
      <!--              <p class="sub-title-apa-pay">00 123 567 | USD</p>-->
      <!--          </div>-->
      <!--          <div class="content-right">-->
      <!--            <a class="change-apa-pay">Change <van-icon name="arrow-down" /></a>-->
      <!--            -->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div
        style="
          margin-top: 15px;
          padding: 16px 16px;
          box-shadow:
            0 3px 6px rgba(0, 0, 0, 0.6),
            0 3px 6px rgba(0, 0, 0, 0.2);
        "
      >
        <!--        {{ $filters.truncate("credit-card-image credit-card-image credit-card-image", 30, '...') }}-->
        <!--        <div class="credit-card">-->
        <div
          class="credit-card"
          v-if="defaultAcc && defaultAcc.accountName != ''"
        >
          <!--        <div class="credit-card">-->
          <!-- <div class="credit-card"> -->
          <div style="">
            <div class="icon-aba-pay">
              <img class="credit-card-image" src="@/static/abapay.svg" />
              <span
                class="credit-card-title fw-bold"
                :style="{ fontSize: '15px' }"
                >ABA PAY</span
              >
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 16px 0px;
              "
            >
              <div>
                <div
                  class="saving-account savingname-container fw-bold limited-text"
                >
                  {{ defaultAcc.accountName }}
                </div>
                <span class="credit-card-phone">
                  {{ formatPhoneNumber(defaultAcc.accountNumber) }} |
                  {{ defaultAcc.currency }}
                </span>
              </div>

              <div
                :class="{ disabled: showLoading }"
                class="saving-change"
                @click="((showLoading = true), debouncedHandleClick(false))"
              >
                <div
                  style="
                    display: flex;
                    height: 22px;
                    justify-items: center;
                    justify-content: center;
                    gap: 4px;
                    align-items: center;
                  "
                >
                  <div :style="{ color: color_primary() }">
                    {{ $t("fuction_change") }}
                  </div>
                  <div style="width: 16px; height: 16px">
                    <img
                      class="saving-change-icon"
                      src="@/static/icon-change-pay.svg"
                      alt="icon change"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-bottom">
          <van-button
            :disabled="showLoading"
            @click="
              ((showLoading = true),
              debouncedHandleClick(checkDefaultAccount()))
            "
            class="btn-buy"
            type="danger"
            :color="color_primary()"
          >
            <p class="btn-buy-content" v-if="item.price">
              {{ $t("buy") }} ${{ parseFloat(item.price).toFixed(2) }}
            </p>
          </van-button>

          <!--        <div v-if="isMetfoneNumber"  class="btn-auto-renew">-->
          <!--          <div style="width: 50px;">-->
          <!--            <van-switch v-model="switchChecked" size="15" active-color="#0D993D">-->
          <!--            </van-switch>-->
          <!--          </div>-->
          <!--          <div>-->
          <!--            <span class="btn-auto-renew-title"> {{ $t("auto_renew") }} </span>-->
          <!--            <div class="btn-auto-renew-description">-->
          <!--              {{ $t("if_auto_renew") }}-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
          <!--        -->
        </div>
      </div>
    </div>
    <metfone-notify
      v-model:is-show.sync="checkMobileMetfoneNumber"
    ></metfone-notify>

    <!-- Fail TV360 Dialog -->
    <FailTV360Dialog
      v-model:is-show="showFailTV360Dialog"
      :title="failDialogTitle"
      :message="failDialogMessage"
      @sign-up="handleCloseFailDialogAndSignUp"
      @close="handleCloseFailDialog"
    />

    <!-- Processing TV360 Dialog -->
    <ProcessingTV360Dialog
      v-model:is-show="showProcessingTV360Dialog"
      :title="processingDialogTitle"
      :message="processingDialogMessage"
      @close="handleCloseProcessingDialog"
    />
  </van-popup>
</template>

<script>
import { Switch, Popup, Button, Field, NumberKeyboard } from "vant";
import ConfirmServiceItem from "@/pages/TV360/components/confirm-service-item";
import { mapState } from "vuex";
import MetfoneNotify from "@/components/metfone-notify";
import { useVuelidate } from "@vuelidate/core";
import { required, minLength, maxLength, helpers } from "@vuelidate/validators";
import _ from "lodash";
import Loading from "@/components/loading";
import { CONSTANTS } from "@/helpers/constants";
import { encrypt, sign, keyToPem } from "anhdev99.rsa";
import {
  formatDateToDDMMYYYYHHMMSS,
  formatDateToEN_US,
} from "@/ultis/dateFormat";
import { ref } from "vue";
import { AsYouType, parsePhoneNumber } from "libphonenumber-js";
import { mask } from "vue-the-mask";
import getErrorMessage from "@/helpers/error-server";
import FailTV360Dialog from "@/pages/TV360/components/fail-tv360-dialog.vue";
import ProcessingTV360Dialog from "@/pages/TV360/components/processing-tv360-dialog.vue";
import {
  claimGetStatusOwner,
  releaseGetStatusOwner,
  runGetStatusOnce,
} from "@/ultis/getStatusGuard";

export default {
  name: "ConfirmPurchase",
  components: {
    Loading,
    MetfoneNotify,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Field.name]: Field,
    [NumberKeyboard.name]: NumberKeyboard,
    ConfirmServiceItem,
    FailTV360Dialog,
    ProcessingTV360Dialog,
  },
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: false,
    },
  },
  directives: { mask },
  setup() {
    const show = ref(false);
    const phoneNumberInput = ref(null);
    const phoneNumberInputtest = ref(null);
    // const phoneNumber = ref('');
    return { v$: useVuelidate(), show, phoneNumberInput, phoneNumberInputtest };
  },
  validations() {
    return {
      phoneNumber: {
        required,
        // regex: alphaNumAndDotValidator,
        minLength: minLength(8),
        maxLength: maxLength(19),
      }, // Matches this.firstName
    };
  },
  data() {
    return {
      showPopoverNunberPhoneInfo: false,
      showDetail: false,
      switchChecked: false,
      payment: {
        amount: "",
        account: "",
        currency: "USD",
        additionalKey: {
          autoRenew: false,
          msisdn: "",
          remark: "",
        },
      },
      defaultAcc: {
        accountName: "",
        accountNumber: "",
        currency: "",
      },
      loading: false,
      checkMobileMetfoneNumber: false,
      isMetfoneNumber: true,
      phoneNumber: "",
      showLoading: false,
      showFailTV360Dialog: false,
      showProcessingTV360Dialog: false,
      failDialogTitle: "",
      failDialogMessage: "",
      processingDialogTitle: "",
      processingDialogMessage: "",
      //description:'<div data-v-64d8a67e="">You are buying a DataOsja package:</div><ol data-v-64d8a67e=""><li data-v-64d8a67e="">Validity: 30 days</li><li data-v-64d8a67e="">Internet data: 50 GB</li><li data-v-64d8a67e="">On-net calls: 5000 mins</li><li data-v-64d8a67e="">On-net SMS: 5000 SMS</li></ol>',
      description: "",
      //dataMessage: "<data>    <merchantAccount>EMONEY</merchantAccount>    <isdn>855972152686</isdn>    <packageCode>DATA_1</packageCode>    <serviceType>EXCHANGE_DATA_OSJA</serviceType>    <time>02/08/2023 16:28:11</time>    <requestId>230801000000000</requestId>    <account>855886391183</account></data>",
      dataMessage: "",
      transactionId: "",
      resultSuccess: null,
      isdn: null,
      checkIsdn: false,
      startY: null,
      maxLength: 25,
      cursorPositionBefore: 0,
      asYouTypeCountry: "KH",
      isDeleted: false,
      oldPhone: "",
      spacing: 0,
      firstLoadItem: false,
      isActionScheduled: false,
      isPaste: false,
      currentPositionInsert: 0,
      lengthTextInsert: 0,
      checkIsPaste: false,
      checkIsDeleted: false,
      isMaxPaste: false,
      isDev: false,
      checkPaymentStatusABA_isDev: false,
      requestId: null,
      hashPayment: null,
    };
  },
  async created() {
    this.loadFirstPhoneNumber();
    await this.getDefaultAcc();
  },
  computed: {
    ...mapState("userStore", [
      "profile",
      "changeProfile",
      "phoneNumberIsMetfone",
      "defaultParam",
    ]),
    getPrice() {
      return this.item ? this.item.price : "0";
    },
    truncatedData() {
      if (this.defaultAcc && this.defaultAcc.accountName) {
        let longData = this.defaultAcc.accountName;
        return longData.length > this.maxLength
          ? longData.slice(0, this.maxLength) + "..."
          : longData;
      }
      return "";
      // Truncate the data if it exceeds the maximum length
    },
  },
  watch: {
    phoneNumber(newValue, oldValue) {
      if (this.isPaste) {
        this.isPaste = false;
        // this.phoneNumber = this.formatPhoneNumberTwo(val);
        const character = this.phoneNumber.slice(-1);
        const parsedCharacter = this.parseDigit(character);
        this.phoneNumber =
          parsedCharacter === "+"
            ? parsedCharacter
            : this.phoneNumber.substring(0, this.phoneNumber.length - 1) +
              parsedCharacter;

        // const {text, invalid} = this.formatPhoneNumberTwo(this.phoneNumber);

        const text = this.formatPhoneNumberTwo(this.phoneNumber.trim());
        this.phoneNumber = text;

        let checkEmpty =
          oldValue != null
            ? oldValue[this.currentPositionInsert] === " "
            : false;
        var lastIndex1 =
          oldValue != null ? (oldValue.match(/ /g) || []).length : 0;
        var lastIndex2 = text != null ? (text.match(/ /g) || []).length : 0;
        var temp = this.phoneNumber.substring(
          this.currentPositionInsert,
          this.currentPositionInsert +
            this.lengthTextInsert +
            (checkEmpty ? (lastIndex2 > lastIndex1 ? lastIndex2 : 0) : 0),
        );
        var lastIndex = (temp.match(/ /g) || []).length;

        this.$nextTick().then(() => {
          // console.log("this.currentPositionInsert + this.lengthTextInsert +lastIndex",this.currentPositionInsert ,this.lengthTextInsert ,lastIndex)
          this.phoneNumberInput.selectionStart =
            this.currentPositionInsert +
            this.lengthTextInsert +
            lastIndex +
            (this.isMaxPaste ? 1 : 0);
          this.phoneNumberInput.selectionEnd =
            this.currentPositionInsert +
            this.lengthTextInsert +
            lastIndex +
            (this.isMaxPaste ? 1 : 0);
          this.isMaxPaste = false;
        });

        let rep = this.formatSpacingPhoneNumber(this.phoneNumber);
        console.log("rep", rep, "this.phoneNumber", this.phoneNumber);
        var formatPhoneNumberCheck = this.regexMetfone(rep);
        if (!formatPhoneNumberCheck) {
          this.checkIsdn = true;
          return;
        } else {
          this.checkIsdn = false;
        }
      }
    },
    checkMobileMetfoneNumber(val) {
      if (val == false) {
        this.phoneNumber = "";
      }
      this.checkIsdn = false;
    },
    async isShow(val) {
      if (val) await this.getDefaultAcc();

      this.showDetail = val;
    },
    item() {
      this.loadFirstPhoneNumber();
    },
  },
  beforeUnmount() {
    releaseGetStatusOwner(this);
    if (this.handlePopState) {
      window.removeEventListener("popstate", this.handlePopState);
    }
  },
  async mounted() {
    this.handlePopState = () => {
      const hash = window.location.hash;
      console.log("[popstate] confirm-purchase-tv360.vue", hash);

      // Nếu đang ở dialog processing và URL không còn dialog param → đóng dialog processing
      if (
        this.showProcessingTV360Dialog &&
        !hash.includes("dialog=processingtv360")
      ) {
        console.log("[TV360] Closing processing dialog via popstate");
        this.showProcessingTV360Dialog = false;
        return;
      }

      // Nếu đang ở dialog fail dialog và URL không còn dialog param → đóng dialog fail
      if (this.showFailTV360Dialog && !hash.includes("dialog=failtv360")) {
        console.log("[TV360] Closing fail dialog via popstate");
        this.showFailTV360Dialog = false;
        return;
      }

      // Nếu popup purchase đang mở và URL không còn action param → đóng popup purchase
      if (
        this.showDetail &&
        !hash.includes("action=confirmpurchasetv360") &&
        !this.showFailTV360Dialog &&
        !this.showProcessingTV360Dialog
      ) {
        console.log("[TV360] Closing popup via popstate");
        this.showDetail = false;
        return;
      }
    };
    window.addEventListener("popstate", this.handlePopState);

    this.loadFirstPhoneNumber();
    this.showDetail = this.isShow;

    claimGetStatusOwner(this);
    this.$bridge.registerHandler("getStatus", async (data) => {
      await runGetStatusOnce(this, data, async (payload) => {
        this.showLoading = true;
        await this.timeout(1000);
        if (payload) {
          this.transactionId = payload.transactionId;
          let mesStatus = `<data><merchantAccount>MINI_APP</merchantAccount><isdn>${this.formatSpacingPhoneNumber(this.phoneNumber)}</isdn><accountABA>${this.profile.appId}</accountABA><requestId>${this.requestId}</requestId><amount>${this.item.price}</amount></data>`;
          const paramsStatus = this.stateAsObject(this.defaultParam);
          const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
          const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
          paramsStatus.signature = sign(mesStatus, privateKeyPem);
          paramsStatus.encrypt = encrypt(mesStatus, publicKeyPem);

          this.showLoading = true;
          console.log("call this.checkPaymentStatusABA 1");
          await this.checkPaymentStatusABA(paramsStatus);
          this.showLoading = false;
        }
      });
    });
  },
  methods: {
    async preBuyPackageTv360ABA() {
      const params = this.stateAsObject(this.defaultParam);
      if (
        !this.profile ||
        !this.profile.appId ||
        this.profile.appId == undefined
      ) {
        this.showFailDialog(
          `${this.$t("tv360.txt_fail")}`,
          getErrorMessage(998),
        );
        return;
      }

      const payload = {
        merchantAccount: "MINI_APP",
        isdn: this.formatSpacingPhoneNumber(this.phoneNumber),
        accountABA: this.profile.appId,
        packageId: this.item.tv360PackageId,
        packageCode: this.item.serviceCode,
        amount: Number(this.item.price),
      };

      /*
      const payload = {
        merchantAccount: "MINI_APP",
        isdn: this.formatSpacingPhoneNumber(this.phoneNumber),
        accountABA: this.profile.appId,
        packageId: 2,
        packageCode: "METFONE_TV360_Monthly",
        amount: 5,
      };
      */

      console.log("preBuyPackageTv360ABA plaintext data: ", payload);
      let mes = `<data>
        <merchantAccount>${payload.merchantAccount}</merchantAccount>
        <isdn>${payload.isdn}</isdn>
        <accountABA>${payload.accountABA}</accountABA>
        <packageId>${payload.packageId}</packageId>
        <packageCode>${payload.packageCode}</packageCode>
        <amount>${payload.amount}</amount>
        </data>`;
      const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
      const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
      params.encrypt = encrypt(mes, publicKeyPem);
      params.signature = sign(mes, privateKeyPem);
      console.log("preBuyPackageTv360ABA request: ", params);
      const res = await this.$store.dispatch(
        "tv360Store/preBuyPackageTv360ABA",
        params,
      );
      if (res) {
        let result = res.data;
        if (result) {
          console.log("preBuyPackageTv360ABA response: ", result);
          if (result.errorCode == 0) {
            // Validate requestId
            if (
              !result.requestId ||
              result.requestId == "" ||
              result.requestId == null ||
              result.requestId == undefined
            ) {
              this.showFailDialog(
                `${this.$t("tv360.txt_fail")}`,
                getErrorMessage(998),
              );
              this.showLoading = false;
              return null;
            }

            // Validate hashPayment
            if (
              !result.hashPayment ||
              result.hashPayment == "" ||
              result.hashPayment == null ||
              result.hashPayment == undefined
            ) {
              this.showFailDialog(
                `${this.$t("tv360.txt_fail")}`,
                getErrorMessage(998),
              );
              this.showLoading = false;
              return null;
            }

            this.requestId = result.requestId;
            this.hashPayment = result.hashPayment;

            return result;
          } else {
            //TODO: [Hoai] Handle other error codes

            if (result.errorCode == 3) {
              this.showProcessingDialog(
                `${this.$t("tv360.processing_title")}`,
                result.message || getErrorMessage(997),
              );
            } else {
              this.checkIsdn = true;
              /*
              this.showFailDialog(
                `${this.$t("tv360.txt_fail")}`,
                result.message || getErrorMessage(997),
              );
              */
            }
          }
        } else {
          this.showFailDialog(
            `${this.$t("tv360.txt_fail")}`,
            getErrorMessage(997),
          );
        }
      } else {
        this.showFailDialog(
          `${this.$t("tv360.txt_fail")}`,
          getErrorMessage(500),
        );
      }

      return null;
    },

    async checkPaymentStatusABA(paramsStatus, retryCount = 0) {
      const maxRetries = 9;
      const retryDelay = 3000; // 3 seconds
      console.log(
        `Retrying checkPaymentStatusABA, attempt ${retryCount + 1}/${maxRetries}`,
      );
      // Chờ 3 giây trước khi retry
      await this.timeout(retryDelay);

      //Test: bypass_checkPaymentStatusABA
      if (this.checkPaymentStatusABA_isDev) {
        const paymentReference = "TEST_" + new Date().getTime();
        const payload = {
          merchantAccount: "MINI_APP",
          isdn: this.formatSpacingPhoneNumber(this.phoneNumber),
          accountABA: this.profile.appId,
          requestId: this.requestId,
          paymentReference: paymentReference,
        };
        await this.buyPackageTv360ABA(payload);

        return;
      }
      try {
        const res = await this.$store.dispatch(
          "tv360Store/checkPaymentStatusABA",
          paramsStatus,
        );
        if (res) {
          let result = res.data;
          console.log("==>checkStatusResult", result);
          if (result) {
            if (result.errorCode == 0) {
              if (result.checkStatusResponseDTO.state == 5000) {
                const paymentReference =
                  result.checkStatusResponseDTO.paymentReference;
                const payload = {
                  merchantAccount: "MINI_APP",
                  isdn: this.formatSpacingPhoneNumber(this.phoneNumber),
                  accountABA: this.profile.appId,
                  requestId: this.requestId,
                  paymentReference: paymentReference,
                };
                await this.buyPackageTv360ABA(payload);

                return;
              }

              //TODO:
              else if (result.checkStatusResponseDTO.state == 2002) {
                const paymentReference =
                  result.checkStatusResponseDTO.paymentReference;
                const payload = {
                  merchantAccount: "MINI_APP",
                  isdn: this.formatSpacingPhoneNumber(this.phoneNumber),
                  accountABA: this.profile.appId,
                  requestId: this.requestId,
                  paymentReference: paymentReference,
                };
                await this.buyPackageTv360ABA(payload);

                return;
              }

              //
              else if (result.checkStatusResponseDTO.state == 3000) {
                if (retryCount >= maxRetries) {
                  console.log(
                    `Payment status changed to ${result.checkStatusResponseDTO}, stopping retry`,
                  );
                  const mes = `${this.$t("tv360.mess_check_status")} ${
                    result.checkStatusResponseDTO?.paymentStatus
                  } [${result.checkStatusResponseDTO.state}]`;
                  this.showFailDialog(`${this.$t("tv360.txt_fail")}`, mes);
                  return;
                }
                console.log("call this.checkPaymentStatusABA 2");
                await this.checkPaymentStatusABA(paramsStatus, retryCount + 1);
              }
              //
              else {
                const mes = `${this.$t("tv360.mess_check_status")} ${result.checkStatusResponseDTO?.paymentStatus} [${result.checkStatusResponseDTO.state}]`;
                this.showFailDialog(`${this.$t("tv360.txt_fail")}`, mes);
              }
            }
            //
            else {
              this.showFailDialog(
                `${this.$t("tv360.txt_fail")}`,
                result.message ||
                  `${this.$t("tv360.check_payment_status_aba_unsuccessful")}`,
              );
              return;
            }
          }
          //
          else {
            this.showFailDialog(
              `${this.$t("tv360.txt_fail")}`,
              `${this.$t("tv360.check_payment_status_aba_unsuccessful")}`,
            );
          }
        }
        //
        else {
          this.showFailDialog(
            `${this.$t("tv360.txt_fail")}`,
            `${this.$t("tv360.check_payment_status_aba_unsuccessful")}`,
          );
        }
      } catch (error) {
        //
        if (retryCount + 1 < maxRetries) {
          console.log("call this.checkPaymentStatusABA 4 [catch error", error);
          await this.checkPaymentStatusABA(paramsStatus, retryCount + 1);
        }
        //
        else {
          this.showFailDialog(
            `${this.$t("tv360.txt_fail")}`,
            `${this.$t("tv360.check_payment_status_aba_unsuccessful")}`,
          );
        }
      }
    },

    async buyPackageTv360ABA(payload) {
      const params = this.stateAsObject(this.defaultParam);
      console.log("buyPackageTv360ABA plaintext data: ", payload);
      let mes = `<data><merchantAccount>${payload.merchantAccount}</merchantAccount><isdn>${payload.isdn}</isdn><accountABA>${payload.accountABA}</accountABA><requestId>${payload.requestId}</requestId><paymentReference>${payload.paymentReference}</paymentReference></data>`;
      const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
      const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
      params.encrypt = encrypt(mes, publicKeyPem);
      params.signature = sign(mes, privateKeyPem);
      console.log("buyPackageTv360ABA request: ", params);
      const res = await this.$store.dispatch(
        "tv360Store/buyPackageTv360ABA",
        params,
      );

      if (res) {
        let result = res.data;
        if (result) {
          if (result.errorCode == 0) {
            const currentDate = new Date();
            this.resultSuccess = {
              subcribeId: this.transactionId, // TODO: Replace with actual transaction ID from API
              subcribeDate: formatDateToEN_US(currentDate, this.isKHM()),
              paidTo: this.formatSpacingPhoneNumber(this.phoneNumber),
              price: this.item.price,
              unit: this.item.unit,
              packageName: this.item.serviceName,
              validity: this.item.validity,
              fullDes: this.item.fullDes, // HTML formatted package description
            };

            // Save to store instead of query params
            this.$store.dispatch(
              "routerStore/setTv360PaymentResult",
              this.resultSuccess,
            );
            this.$router.replace({ path: "/tv360-payment-success" });
          } else {
            /*
            errorCode = 0 => SUCCESS
            nếu errorCode = 2 => FAIL
            nếu errorCode = 3 => WAITING
            */
            if (result.errorCode == 3) {
              this.$router.replace({ path: "/tv360-request-received" });
            }
            //
            else if (result.errorCode == 2) {
              this.$router.replace({
                path: "/tv360-payment-faild",
                query: { tid: this.transactionId || this.requestId || "" },
              });
            }
            //
            else {
              this.showFailDialog(
                `${this.$t("tv360.txt_fail")}`,
                getErrorMessage(500),
              );
            }
          }
        } else {
          this.showFailDialog(
            `${this.$t("tv360.txt_fail")}`,
            getErrorMessage(996),
          );
        }
      }
      this.showLoading = false;
    },

    //TODO: HOAI Handle Buy TV360 Package: như luồng src\pages\EPayment\index.vue
    async handleBuy(useDefaultAcc = false) {
      console.log("Package info", this.item);
      const respPreBuyPackageTv360ABA = await this.preBuyPackageTv360ABA();
      console.log("preBuyPackageTv360ABA result 1", respPreBuyPackageTv360ABA);
      if (!respPreBuyPackageTv360ABA) {
        console.log("handleBuy 0");
        this.showLoading = false;
        return;
      }

      this.resetPaymentPayload();

      this.payment.useDefault = useDefaultAcc;
      this.payment.account = `${respPreBuyPackageTv360ABA.requestId}`;
      this.payment.amount = this.item.price;
      this.payment.currency = "USD";

      this.payment.additionalKey.msisdn = this.formatSpacingPhoneNumber(
        this.phoneNumber,
      );
      //this.payment.additionalKey.autoRenew = this.switchChecked;
      // Remark
      //===============================================================
      let remarkText = this.formatSpacingPhoneNumber(this.phoneNumber);
      if (remarkText.startsWith("855")) {
        remarkText = remarkText.slice(3);
      }
      if (remarkText.startsWith("0")) {
        remarkText = remarkText.slice(1);
      }
      remarkText = `TV360 : ${remarkText}`;
      this.payment.additionalKey.remark = remarkText;
      //===============================================================
      //this.payment.additionalKey.hash = this.hashPayment;
      //===============================================================

      console.log("[==> doPayment]", this.payment);

      //TODO: HOAI Dev mode skip doPayment call
      if (this.isDev) {
        console.log("Dev mode: Skipping doPayment call");
        this.transactionId = "getStatus_data.transactionId";
        let mesStatus = `<data>
          <merchantAccount>MINI_APP</merchantAccount>
          <isdn>${this.formatSpacingPhoneNumber(this.phoneNumber)}</isdn>
          <requestId>${this.requestId}</requestId>
          <accountABA>${this.profile.appId}</accountABA>          
          <amount>${this.item.price}</amount>
        </data>`;
        const paramsStatus = this.stateAsObject(this.defaultParam);
        const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
        const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
        paramsStatus.signature = sign(mesStatus, privateKeyPem);
        paramsStatus.encrypt = encrypt(mesStatus, publicKeyPem);
        this.showLoading = true;
        console.log("call this.checkPaymentStatusABA", mesStatus);
        await this.checkPaymentStatusABA(paramsStatus);
        this.showLoading = false;
      } else {
        this.$bridge
          .callHandler("doPayment", this.payment)
          .then(() => {
            // console.log("2. Response API: ", data)
          })
          .finally(() => {
            // console.log("2. Response API: ", data)
          });
        setTimeout(() => {
          this.showLoading = false;
        }, 500);
      }
    },

    //===============================================================

    handleOpenContact() {
      console.log("Open contact picker");
      if (this.isDev) {
        const data = {
          name: "Test Contact" + Math.floor(1000 + Math.random() * 9000),
          phone: "+855" + Math.floor(10000000 + Math.random() * 90000000),
        };
        console.log("Dev mode: Contact picker not available", data);
        this.phoneNumber = this.formatPhoneNumberTwo(
          data.phone.replace(/\D/g, ""),
        );
        // Validate phone number after getting from contact
        let rep = this.formatSpacingPhoneNumber(this.phoneNumber);
        let formatPhoneNumberCheck = this.regexMetfone(rep);
        this.checkIsdn = !formatPhoneNumberCheck;
      } else {
        this.$bridge.callHandler("getContact").then((data) => {
          console.log("Contact data:", data);
          if (data && data.phone) {
            this.phoneNumber = this.formatPhoneNumberTwo(
              data.phone.replace(/\D/g, ""),
            );
            // Validate phone number after getting from contact
            let rep = this.formatSpacingPhoneNumber(this.phoneNumber);
            let formatPhoneNumberCheck = this.regexMetfone(rep);
            this.checkIsdn = !formatPhoneNumberCheck;
          }
        });
      }
    },

    color_primary() {
      return CONSTANTS.color_primary;
    },
    formatPhoneNumber(phoneNumber) {
      phoneNumber = phoneNumber.replace(/\D/g, "");

      if (phoneNumber.length >= 7) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{3,4})/, "$1 $2 $3");
      }

      return phoneNumber;
    },
    formatPhoneNumberTwo(phoneNumber) {
      let cleanedNumber = phoneNumber;
      if (cleanedNumber.length >= 3) {
        cleanedNumber = cleanedNumber.replace(/\s+/g, ""); //Remove illegal characters
        if (cleanedNumber.length > 3)
          cleanedNumber = cleanedNumber.replace(/.{3}/, "$& "); //Add hyphen at pos.4
        if (cleanedNumber.length > 7)
          cleanedNumber = cleanedNumber.replace(/.{7}/, "$& ");
        if (cleanedNumber.length >= 11 && cleanedNumber.length <= 12) {
          cleanedNumber = cleanedNumber.replace(/.{13}/, "$& ");
        } else {
          cleanedNumber = cleanedNumber.replace(/.{11}/, "$& ");
        }
        if (cleanedNumber.length >= 15 && cleanedNumber.length <= 16) {
          cleanedNumber = cleanedNumber.replace(/.{17}/, "$& ");
        } else {
          cleanedNumber = cleanedNumber.replace(/.{15}/, "$& ");
        }
        return cleanedNumber;
      } else {
        return phoneNumber;
      }
    },
    checkDefaultAccount() {
      if (
        this.defaultAcc == null ||
        this.defaultAcc == undefined ||
        (this.defaultAcc && this.defaultAcc.accountName == "")
      )
        return false;
      return true;
    },
    isKHM() {
      const currentLanguage = this.$i18n.locale;
      if (currentLanguage == "kh") return true;
      return false;
    },
    onTouchStart(event) {
      this.startY = event.touches[0].clientY;
    },

    onTouchMove(event) {
      if (this.startY === null) return;

      const currentY = event.touches[0].clientY;
      const deltaY = currentY - this.startY;

      // Threshold to decide if it's a swipe down
      if (deltaY > 50) {
        this.$emit("update:isShow", false);
        this.startY = null;
      }
    },
    onTouchEnd() {
      this.startY = null;
    },

    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    async timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    /*
    regexMetfone(phone) {
      if ((phone && phone.length < 8) || phone.length > 16) return false;
      let regex =
        /^(?:00855|855|0)?(31|60|66|67|68|71|88|90|97|236|246|256|266|326|336|346|356|366|426|436|446|526|536|546|556|626|636|646|656|726|736|746|756)\d+$/;
      // let regex = /(00855|855|0|)|(31|60|66|67|68|71|88|90|97|236|246|256|266|326|336|346|356|366|426|436|446|526|536|546|556|626|636|646|656|726|736|746|756)\d{6,7}$/
      // let regex = /^(?:\+855|0)?([689][0-9]|7[0-9]|5[0-4]|3[0-9]|2[0-9]|1[0-9]|0[2-9])\d{6,8}$/;

      // Smart: 10,15,16,69,70,81,86,87,93,96,98
      // Cellcard: 11,12,14,17,61,76,77,78,85,92,95,99
      // Metfone: 88,97,71,31,60,66,67,68,90
      // qb: 13,80,83,84
      // Excell: 18
      // CamTel/Cootel: 38
      //let regex =  /^(?:00855|855|0)?(10|15|16|69|70|81|86|87|93|96|98|11|12|14|17|61|76|77|78|85|92|95|99|88|97|71|31|60|66|67|68|90|13|80|83|84|18|38)\d+$/;
      let result = regex.test(phone);
      return result;
    },
    */

    regexMetfone(phone) {
      if (!phone) return false;
      phone = phone.trim();

      // must be digits only
      if (!/^\d+$/.test(phone)) return false;

      // if starts with country code 855 -> length must be 11 or 12
      if (phone.startsWith("855")) {
        const length = phone.length;
        if (length < 11 || length > 12) return false;
        return true;
      }

      // if starts with 0 remove leading zero for length check
      if (phone.startsWith("0")) {
        phone = phone.substring(1);
      }

      const length = phone.length;
      if (length < 8 || length > 9) return false;
      return true;
    },

    formatSpacingPhoneNumber(phone) {
      return phone.replace(/ /g, "");
    },
    handleClick() {
      // this.phoneNumberInputtest.value = Date.now().toString()
      // this.phoneNumber = this.phoneNumber+ "k";
      // const character = this.phoneNumber.slice(-1);
      // const parsedCharacter = this.parseDigit(character);
      // let isCheckPhone = this.oldPhone.length >= this.phoneNumber.length;
      // // console.log("isCheckPhone", isCheckPhone, this.oldPhone, this.phoneNumber)
      // this.phoneNumber =
      //     parsedCharacter === '+'
      //         ? parsedCharacter
      //         : this.phoneNumber.substring(0, this.phoneNumber.length - 1) + parsedCharacter;
      //
      // this.phoneNumber = this.formatPhoneNumberTwo(this.phoneNumber)
    },
    handleKeyDown2(event) {
      if (event.key === "Backspace" || event.keyCode === 8) {
        const caretPosition = event.target.selectionStart;
        this.cursorPositionBefore = caretPosition;
        const caretPositionEnd = event.target.selectionEnd;
        this.checkIsDeleted = false;
        if (
          caretPositionEnd.length == this.phoneNumber.length &&
          caretPosition.length < caretPositionEnd.length
        ) {
          this.checkIsDeleted = true;
        }
        this.isDeleted = true;
        // let check = this.phoneNumber[caretPosition] === " ";
        // if(check){
        //   this.checkIsDeleted = false;
        // }
        if (caretPosition > 0 && this.phoneNumber[caretPosition - 1] === " ") {
          // this.$nextTick(() => {
          //   this.phoneNumberInput.selectionStart = caretPosition + (check? -1: 0);
          //   this.phoneNumberInput.selectionEnd =caretPosition  + (check? -1: 0);
          // });
        }
      } else {
        this.isDeleted = false;
      }
    },
    handleKeyDown(event) {
      if (this.phoneNumberInput.selectionStart == 0) {
        return;
      }
      if (event.key === "Backspace" || event.keyCode === 8) {
        // console.log("event.target.selectionStart", event.target.selectionStart)
        const caretPosition = event.target.selectionStart;
        const caretPositionEnd = event.target.selectionEnd;
        this.checkIsDeleted = true;
        if (
          caretPositionEnd.length == this.phoneNumber.length &&
          caretPosition.length < caretPositionEnd.length
        ) {
          this.checkIsDeleted = true;
        }

        if (caretPosition > 0 && this.phoneNumber[caretPosition - 1] === " ") {
          var text =
            this.phoneNumber.slice(0, caretPosition - 2) +
            this.phoneNumber.slice(caretPosition);
          this.isDeleted = true;

          const temp = this.phoneNumber.substring(
            this.phoneNumberInput.selectionStart,
          );
          // this.cursorPositionBefore = event.target.selectionStart;
          const spaceCount = temp.split(" ").length - 1;
          // this.phoneNumberInput.selectionStart = this.phoneNumberInput.selectionStart - 2;
          this.phoneNumber = this.formatPhoneNumberTwo(text);
          // console.log("event.target.selectionStart 1", event.target.selectionStart)

          // console.log("this.phoneNumber.length - event.target.selectionStart", this.phoneNumber.length, event.target.selectionStart)
          event.preventDefault();
          this.$nextTick(() => {
            this.phoneNumberInput.selectionStart = caretPosition;
            this.phoneNumberInput.selectionEnd = caretPosition;
          });
          // if(this.phoneNumber.length <= 3)
          //   setTimeout(() =>{  this.phoneNumberInput.setSelectionRange(event.target.selectionStart , event.target.selectionStart)}, 50)
          // else{
          //   setTimeout(() =>{  this.phoneNumberInput.setSelectionRange(event.target.selectionStart - (this.phoneNumber.length - event.target.selectionStart) , event.target.selectionStart -  (this.phoneNumber.length - event.target.selectionStart))}, 50)
          // }
        } else {
          // console.log("event.target.selectionStart", event.target.selectionStart)
          this.isDeleted = true;
          if (this.phoneNumber.indexOf(" ") !== -1 && this.isDeleted) {
            const temp = this.phoneNumber.substring(
              this.phoneNumberInput.selectionStart,
            );
            const spaceCount = temp.split(" ").length - 1;
            // this.cursorPositionBefore =this.phoneNumberInput.selectionStart - 1;
            let text =
              this.phoneNumber.slice(0, caretPosition) +
              this.phoneNumber.slice(caretPosition);
            this.phoneNumber = this.formatPhoneNumberTwo(text);
            // console.log("event.target.selectionStart 2", text)
            // setTimeout(() => {this.phoneNumberInput.setSelectionRange(event.target.selectionStart , event.target.selectionStart )}, 0)
            // event.preventDefault();
            // event.preventDefault();
            setTimeout(
              () =>
                this.phoneNumberInput.setSelectionRange(
                  event.target.selectionStart +
                    (spaceCount > 1
                      ? spaceCount - 1
                      : spaceCount == 0
                        ? 0
                        : spaceCount),
                  event.target.selectionStart +
                    (spaceCount > 1
                      ? spaceCount - 1
                      : spaceCount == 0
                        ? 0
                        : spaceCount),
                ),
              100,
            );
          } else {
            this.isDeleted = false;
          }
        }
      } else {
        this.isDeleted = false;
      }
    },
    parseDigit(character) {
      return /\d/.test(character) ? character : "";
    },
    formatPhoneNumber1(value) {
      let text;
      let template;
      let isValid;
      let nationNumber;
      try {
        const phoneNumber = parsePhoneNumber(value, this.asYouTypeCountry);
        const asYouType = new AsYouType(this.asYouTypeCountry);
        text = asYouType.input(value);
        template = asYouType.getTemplate();
        isValid = asYouType.isValid();

        text = phoneNumber.formatNational();
      } catch (error) {
        if (error.message.indexOf("Unknown country") === 0) {
          text = value;
          template = value.replace(/./g, "x");
        } else {
          throw error;
        }
      }
      return { text, template, isValid, nationNumber };
    },
    extractNumbers(text) {
      // Use regex to match numbers in the input string
      const numberRegex = /\d+/g;

      // Match all numbers in the input string
      // const matches = text.match(numberRegex);

      // Update the extractedNumbers data property with the matched numbers as a string
      const matches = (text.match(numberRegex) || []).join("");
      return matches;
    },
    handlePaste(event) {
      event.preventDefault();

      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text",
      );
      const extractNumbers = this.extractNumbers(pastedText);
      const textBeforeSelection = this.phoneNumberInput.selectionStart;
      const textAfterSelection = this.phoneNumberInput.selectionEnd;
      // Insert the pasted text at the specified position
      if (this.phoneNumber == null) this.phoneNumber = "";
      const modifiedText =
        this.phoneNumber.slice(0, textBeforeSelection) +
        extractNumbers +
        this.phoneNumber.slice(textAfterSelection);
      // console.log("modifiedText.length",this.formatPhoneNumberTwo(modifiedText).length, modifiedText)
      this.isMaxPaste = false;
      let phoneNumberFormat = this.formatPhoneNumberTwo(modifiedText).substring(
        0,
        19,
      );
      if (this.formatPhoneNumberTwo(modifiedText).length >= 19) {
        this.phoneNumber = this.formatSpacingPhoneNumber(phoneNumberFormat);

        this.isMaxPaste = textBeforeSelection === 0;
      } else {
        // console.log("phoneNumberFormat", phoneNumberFormat.length)
        this.isMaxPaste =
          phoneNumberFormat.length == 14 || phoneNumberFormat.length == 18;
        this.phoneNumber = this.formatSpacingPhoneNumber(
          this.formatPhoneNumberTwo(modifiedText),
        );
      }

      this.checkIsPaste = true;
      this.isPaste = true;
      this.currentPositionInsert = textBeforeSelection;
      this.lengthTextInsert = extractNumbers.length;
    },
    debounceInput: _.debounce(function (e) {
      const caretPosition = this.phoneNumberInput.selectionStart;

      /*
      // const caretPosition = e.target.selectionStart;
      var phone = this.regexMetfone(e.target.value);
      if (phone) {
        return;
      }
      */
      const currentRaw = (e && e.target && e.target.value) || "";
      const repNow = this.formatSpacingPhoneNumber(currentRaw);
      this.checkIsdn = !this.regexMetfone(repNow);

      // console.log("1231")
      //
      // if(this.isDeleted)
      //   return;
      const character = this.phoneNumber.slice(-1);
      const parsedCharacter = this.parseDigit(character);
      let isCheckPhone = this.oldPhone.length >= this.phoneNumber.length;
      // console.log("isCheckPhone", isCheckPhone, this.oldPhone, this.phoneNumber)
      this.phoneNumber =
        parsedCharacter === "+"
          ? parsedCharacter
          : this.phoneNumber.substring(0, this.phoneNumber.length - 1) +
            parsedCharacter;

      // const {text, invalid} = this.formatPhoneNumberTwo(this.phoneNumber);

      const text = this.formatPhoneNumberTwo(this.phoneNumber.trim());
      // console.log("textt: asdf sadf", text, this.isDeleted)
      this.cursorPositionBefore = this.phoneNumberInput.selectionStart;

      this.phoneNumber = text;

      if (this.phoneNumber.indexOf(" ") !== -1 && this.isDeleted == false) {
        // var temp = this.phoneNumber.substring(this.cursorPositionBefore - 1);
        // var lastIndex  = this.phoneNumber.lastIndexOf(" ");
        // var spaceCount =temp.split(" ").length - 1;

        var spaceTwo = this.phoneNumber.split(" ").length >= 2;
        var isOldSpace = e.target.value.length >= this.oldPhone.length;
        var isChange = false;
        // console.log("IsOld", isOldSpace)
        // if(this.spacing != ( this.phoneNumber.match(/ /g) || []).length){
        //   console.log(this.phoneNumber.split(" ").length)
        //   this.spacing = ( this.phoneNumber.match(/ /g) || []).length
        //   isChange = true;
        // }else{
        //   // this.spacing =0
        //   isChange = false;
        // }
      }
      if (this.spacing != (this.phoneNumber.match(/ /g) || []).length) {
        console.log(this.phoneNumber.split(" ").length);
        this.spacing = (this.phoneNumber.match(/ /g) || []).length;
        isChange = true;
      } else {
        // this.spacing =0
        isChange = false;
      }
      var temp = this.phoneNumber.substring(caretPosition);
      var lastIndex = (temp.match(/ /g) || []).length;
      var pointerNearEmpty = this.phoneNumber[caretPosition - 1] === " ";
      var lastNumber = this.phoneNumber[caretPosition - 1] === " ";
      // console.log("Update",lastNumber)

      let check1 = this.phoneNumber.length === e.target.selectionStart;

      // if(this.phoneNumber.length > 18)
      //   setTimeout(() => this.phoneNumberInput.setSelectionRange(this.cursorPositionBefore , this.cursorPositionBefore), 10)
      // else
      //     // setTimeout(() =>{  this.phoneNumberInput.setSelectionRange(this.cursorPositionBefore ,this.cursorPositionBefore)}, 50)
      //   setTimeout(() => this.phoneNumberInput.setSelectionRange(this.cursorPositionBefore + (spaceCount > 0 ? lastIndex !== -1 && lastIndex > this.cursorPositionBefore ? 0 : isCheckPhone ? spaceCount - 1 : spaceTwo ? spaceCount :  -1: 0 ), this.cursorPositionBefore +  (spaceCount > 0 ? lastIndex !== -1 && lastIndex > this.cursorPositionBefore ? 0 : isCheckPhone ? spaceCount - 1 :spaceTwo ? spaceCount : -1: 0 )), 50)
      // //
      this.isActionScheduled = true;
      this.$nextTick().then(() => {
        if (this.isActionScheduled) {
          // this.phoneNumberInput.selectionStart =caretPosition  + (spaceCount > 0 ? lastIndex !== -1 && lastIndex > caretPosition ? 0 : isCheckPhone ? spaceCount - 1 : isChange && spaceTwo ? 0: isChange ? spaceCount : 0:  1 );
          // this.phoneNumberInput.selectionEnd =caretPosition + (spaceCount > 0 ? lastIndex !== -1 && lastIndex > caretPosition ? 0 : isCheckPhone ? spaceCount - 1 : isChange && spaceTwo ? 0:  isChange ? spaceCount : 0:  1 );
          // console.log(' this.spacing', this.spacing, e.target.selectionStart, lastIndex, isChange, lastNumber, this.cursorPositionBefore, this.firstLoadItem, check1, this.phoneNumber.length == e.target.selectionStart, "test", this.firstLoadItem || !check1, this.checkIsPaste)
          // console.log(" this.checkIsDeleted",  this.firstLoadItem || !check1 || this.checkIsPaste || this.checkIsDeleted)
          // if(!this.checkIsDeleted){
          //   this.checkIsPaste = false
          // }
          let checkPhone1417 =
            this.checkIsPaste &&
            (this.phoneNumber.length == 12 || this.phoneNumber.length == 16);
          // console.log("checkPhone1417: ", checkPhone1417, this.phoneNumber.length)
          this.phoneNumberInput.selectionStart = this.isDeleted
            ? isChange
              ? this.firstLoadItem ||
                !check1 ||
                this.checkIsPaste ||
                this.checkIsDeleted
                ? checkPhone1417
                  ? caretPosition - 1
                  : caretPosition
                : caretPosition - 1
              : caretPosition
            : caretPosition +
              (!isChange || lastIndex != 0 ? (pointerNearEmpty ? 1 : 0) : 1);
          this.phoneNumberInput.selectionEnd = this.isDeleted
            ? isChange
              ? this.firstLoadItem ||
                !check1 ||
                this.checkIsPaste ||
                this.checkIsDeleted
                ? checkPhone1417
                  ? caretPosition - 1
                  : caretPosition
                : caretPosition - 1
              : caretPosition
            : caretPosition +
              (!isChange || lastIndex != 0 ? (pointerNearEmpty ? 1 : 0) : 1);

          this.firstLoadItem = false;
          this.isActionScheduled = false;
          // if(this.checkIsPaste){
          //   this.checkIsPaste = false;
          // }
        }
      });
      this.oldPhone = JSON.parse(JSON.stringify(this.phoneNumber));
      // if (!isValid){
      //   this.checkIsdn = true;
      //
      //   return;
      // }else{
      //   this.checkIsdn = false;
      // }

      let rep = this.formatSpacingPhoneNumber(this.phoneNumber);
      var formatPhoneNumberCheck = this.regexMetfone(rep);
      if (!formatPhoneNumberCheck) {
        this.checkIsdn = true;
        return;
      } else {
        this.checkIsdn = false;
      }

      if (
        this.profile &&
        this.phoneNumber != this.formatPhone(this.profile.phone)
      ) {
        this.isMetfoneNumber = false;
      } else {
        this.isMetfoneNumber = true;
      }
    }, 0),
    checkValidate() {},
    resetPaymentPayload() {
      this.payment = {
        amount: "0",
        currency: "",
        useDefault: false,
        account: "", // something that unique like transaction_id|invioce_id|ticket_id
        additionalKey: {
          autoRenew: false,
          remark: "",
        },
      };
    },
    handlerClose() {
      this.$emit("update:isShow", false);
      // Chỉ back nếu URL có action param (để pop history entry đúng)
      if (window.location.hash.includes("action=confirmpurchasetv360")) {
        history.back();
      }
    },
    async getDefaultAcc() {
      // console.log("this.getPrice", this.getPrice, this.item)
      if (this.getPrice != "0") {
        this.$bridge
          .callHandler("getDefaultAcc", {
            currency: "USD",
            amount: this.getPrice,
            // amount: 20000000000,
          })
          .then((res) => {
            if (res && res.accountName) this.defaultAcc = res;
            else {
              this.defaultAcc.accountName = "";
              this.defaultAcc.accountNumber = "";
              this.defaultAcc.currency = "USD";
            }
          });
      }
    },
    debouncedHandleClick: _.debounce(function (useDefaultAcc = false) {
      this.handleBuy(useDefaultAcc);
    }, 200),

    showFailDialog(title = "", message = "") {
      this.failDialogTitle = title || this.$t("tv360.fail_title");
      this.failDialogMessage = message || this.$t("tv360.fail_message");
      if (!window.location.hash.includes("dialog=failtv360")) {
        const newUrl =
          window.location.origin +
          window.location.pathname +
          "#/home?tab=tabTV360&action=confirmpurchasetv360&dialog=failtv360";
        history.pushState(null, "", newUrl);
      }
      this.showFailTV360Dialog = true;
    },

    showProcessingDialog(title = "", message = "") {
      this.processingDialogTitle = title || this.$t("tv360.processing_title");
      this.processingDialogMessage =
        message || this.$t("tv360.processing_message");
      if (!window.location.hash.includes("dialog=processingtv360")) {
        const newUrl =
          window.location.origin +
          window.location.pathname +
          "#/home?tab=tabTV360&action=confirmpurchasetv360&dialog=processingtv360";
        history.pushState(null, "", newUrl);
      }
      this.showProcessingTV360Dialog = true;
    },

    // Đóng processing dialog bằng nút (không phải back) - cần pop history entry
    handleCloseProcessingDialog() {
      if (window.location.hash.includes("dialog=processingtv360")) {
        /*
        const newUrl =
          window.location.origin +
          window.location.pathname +
          "#/home?tab=tabTV360&action=confirmpurchasetv360";
        history.pushState(null, "", newUrl);
        */
        history.back();
      } else {
        this.showProcessingTV360Dialog = false;
      }
    },

    // Đóng fail dialog bằng nút (không phải back) - cần pop history entry
    handleCloseFailDialog() {
      if (window.location.hash.includes("dialog=failtv360")) {
        /*
        const newUrl =
          window.location.origin +
          window.location.pathname +
          "#/home?tab=tabTV360&action=confirmpurchasetv360";
        history.pushState(null, "", newUrl);
        */
        history.back();
      } else {
        this.showFailTV360Dialog = false;
      }
    },

    // Đóng fail dialog và sign up
    handleCloseFailDialogAndSignUp() {
      // Chỉ back nếu URL có dialog param
      if (window.location.hash.includes("dialog=failtv360")) {
        history.back();
      } else {
        this.showFailTV360Dialog = false;
      }
      // Sau đó gọi sign up
      this.$nextTick(() => {
        this.handleSignUpTV360();
      });
    },

    loadFirstPhoneNumber() {
      this.phoneNumber = null;
      this.checkIsdn = false;
      this.isMetfoneNumber = this.phoneNumberIsMetfone;
      if (this.profile && this.profile.phone) {
        let phone = this.profile.phone;
        let tempPhone = phone.replace(/\D/g, "");
        const modifiedNumber = tempPhone.replace(/^855/, "0");
        // this.checkMobileMetfoneNumber = !this.regexMetfone(tempPhone);
        const text = this.formatPhoneNumberTwo(modifiedNumber);
        this.phoneNumber = text;
      }
      // const text = this.formatPhoneNumberTwo("031544520");
      // this.phoneNumber = text;
      this.firstLoadItem = true;
      // if(this.phoneNumberInput){
      //   this.phoneNumberInput.selectionStart = this.phoneNumber.length;
      //   this.phoneNumberInput.selectionEnd =this.phoneNumber.length;
      // }
      //
    },
    getCheckShowModalMetfone() {
      let phone = this.phoneNumber;
      let tempPhone = phone.replace(/\D/g, "");
      this.checkMobileMetfoneNumber = !this.regexMetfone(tempPhone);
      return this.checkMobileMetfoneNumber;
    },
    formatPhone(val) {
      let tempPhone = val.replace(/\D/g, "");
      return tempPhone;
    },
    handleSignUpTV360() {
      // TODO: Hoai - Handle sign up TV360
      console.log("Sign up TV360");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-detail {
  //padding: 0 16px;

  .credit-card-title {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    /* 128.571% */
    text-transform: uppercase;
    margin-left: 10px;
  }

  .close-line {
    display: flex;
    justify-content: center;
    padding: 16px;

    .close-line-item {
      width: 40px;
      height: 4px;
      border-radius: 4px;
      background: #90a3bf;
    }
  }

  .detail-title {
    color: #101828;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 10px;
    margin: 16px 0px;
  }

  .card-line {
    border-top: 1px dashed #c9c9c9;
  }

  .card-description {
    color: #667085;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;

    div {
      margin: 0 0 3px 0;
    }

    ol {
      list-style: inside;
      padding-left: 8px;

      li {
        color: #667085;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.14px;
        margin: 0 0 3px 0;
      }
    }
  }

  .phone-number {
    margin-bottom: 0px;
    border-radius: 8px;
    border: 1px solid var(--gray-300, #d0d5dd);
    background: var(--white, #fff);
    /* Shadow/xs */
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .input-phone-number {
      width: 100%;
      border: none;
    }

    .van-cell.van-field {
      padding: 0px;
    }
  }

  .btn-bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .btn-buy {
      display: flex;
      padding: 13px 0px;
      height: 48px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      //flex: 1 0 0;
      width: 100%;
      border-radius: 8px;
      background: #ef5350;
      flex-shrink: 0;

      /* Shadow/xs */
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
      //margin: 16px 0;
      margin-top: 0px;

      .btn-buy-content {
        color: var(--White, #fff);
        text-align: center;
        font-size: 16px;
        font-family: Inter;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        /* 137.5% */
        letter-spacing: -0.066px;
        margin-bottom: 0;
      }
    }

    .btn-auto-renew {
      display: flex;
      justify-content: start;
      align-items: start;
      gap: 12px;
      width: 100%;
    }

    .btn-auto-renew-title {
      color: #272d37;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }

    .btn-auto-renew-description {
      color: #8e9196;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }
  }

  .input-errors {
    font-size: 12px;
    color: orangered;
    margin-top: 4px;
  }

  .phone-number-title {
    color: #272d37;
    font-feature-settings:
      "clig" off,
      "liga" off;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.14px;
    margin-bottom: 6px;
  }

  .metfone-tooltip {
    padding: 6px 8px;
    align-items: center;

    p {
      color: var(--f, #fff);
      font-family: Roboto;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 162.687%;
      /* 16.269px */
      letter-spacing: -0.181px;
    }
  }

  .icon-aba-pay {
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .credit-card-image {
    background-color: #005d85;
    image-rendering: pixelated;
    height: 18px;
    width: 30px;
    border-radius: 5px;
  }

  .credit-card-title {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    /* 128.571% */
    text-transform: uppercase;
    width: 71px;
  }

  .saving-account {
    color: #000;
    font-family: Inter;
    font-style: normal;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    /* 137.5% */
    letter-spacing: -0.066px;
  }

  .credit-card-phone {
    //color: #000;
    //font-size: 12px;
    //font-style: normal;
    //font-weight: 500;
    //line-height: normal;
    opacity: 0.5;
    color: #000;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .saving-change {
    //color: #EF5350;
    //text-align: right;
    //font-size: 13px;
    //font-style: normal;
    //font-weight: 600;
    //line-height: 22px;
    /* 137.5% */
    //letter-spacing: -0.066px;

    display: flex;
    justify-content: center;

    color: #ef5350;
    text-align: right;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 137.5% */
  }

  .credit-card {
    //margin-top: 16px;
  }
}

.aba-pay {
  margin-top: 16px;
}

.content-apa-pay {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  line-height: 1.4rem;
}

.title-apa-pay {
  font-size: 17px;
  font-weight: bold;
  margin: 0;
  margin-bottom: 4px;
}

.sub-title-apa-pay {
  margin: 0;
  opacity: 50%;
  size: 12px;
}

.change-apa-pay {
  color: #ef5350;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.saving-change-icon {
  display: flex;
  justify-content: start;
  text-align: start;
  justify-items: start;
}

.savingname-container {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  padding-right: 5px;
}

.disabled {
  pointer-events: none;
  /* Disables all pointer events */
  opacity: 0.5;
  /* Visually indicate the element is disabled */
}

.btn-contact {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 5px;
}
</style>
